import {API, BASE_URL} from './config';

export default {
    bookingListApi: async ()=>{
        try {
            const response = await API.get(`${BASE_URL}/webapi/booking/list`);
            // console.log('response', response.data)
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },
      assignCenter: async(id,reqBody)=>{
        try {
            const response = await API.post(`${BASE_URL}/webapi/booking/assign-center/${id}`,reqBody);
            return response;
        } catch (error) {
            console.log("error", error)
            return error.response
        }
    },

    bookingDetailApi: async(id)=>{
        try {
            const response = await API.post(`${BASE_URL}/webapi/booking/detail/${id}`);
            return response
        } catch (error) {
            return error.response
        }
    },

    assignCardiologist: async(reqBody)=>{
        try {
            const response = await API.post(`${BASE_URL}/webapi/booking/assign-cardiologist`,reqBody);
            return response;
        } catch (error) {
            return error.response
        }
    },

    tansactionList: async ()=>{
        try {
            const response = await API.get(`${BASE_URL}/webapi/booking/transaction-list`);
            // console.log('response', response.data)
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },
    
    userBookingList: async (id)=>{
        try {
            const response = await API.get(`${BASE_URL}/api/booking/details/${id}`);
            console.log('response', response.data)
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },
}